// src/apps/frontend/routes/index.tsx
import {Routes, Route, Navigate} from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Login from "../pages/Login.tsx";
import Logout from "../pages/Logout.tsx";
import Apps from "~/apps/auth/pages/Apps.tsx";
import Callback from "~/apps/auth/pages/Callback.tsx";

export const AuthRoutes = () => {
    return (
        <MainLayout>
            <Routes>
                <Route path='/' element={<Apps />}/>
                <Route path='/login' element={<Apps />}/>
                <Route path='/app/:public_id/login' element={<Login />}/>
                <Route path='/callback/:public_id' element={<Callback />}/>
                <Route path='/logout' element={<Logout />}/>
                <Route path="*" element={<Navigate to="/errors/404" replace />} />
            </Routes>
        </MainLayout>
    );
}
